import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "horizontalLine",
  props: {
    width: {
      prop: "other",
      type: "slider",
      value: "100%",
    },
    borderStyle: {
      prop: "other",
      type: "select",
      value: "solid",
      options: [
        {
          value: "Solid",
          label: "builder_ui.prop_type.styles.border_style_types.solid",
        },
        {
          value: "Dashed",
          label: "builder_ui.prop_type.styles.border_style_types.dashed",
        },
      ],
    },
    color: {
      prop: "other",
      type: "color",
      value: "var(--theme-website-color-border-primary)",
    },
    borderWidth: {
      prop: "other",
      type: "slider",
      value: 1,
    },
    paddingY: {
      prop: "other",
      type: "slider",
      value: 0,
    },
    paddingX: {
      prop: "other",
      type: "slider",
      value: 0,
    },
  },
};
